import React from 'react';

import UserEditForm2 from "./ReactUserEditForm2";
import DesiTeacherChildrenPanel from "./ReactDesiTeacherChildrenPanel";

import DropdownRole from "root/ReactHookForm/ui/DropdownRole";
import DropdownDesignatedTeachers from "../UI/ReactDropdownDesignatedTeachers";

import { UserTypes } from "root/DataFunctions/Constants";
import SpinnerDiv from "ui/SpinnerDiv";
import {createESWUser, createUser, deleteUser} from "../DataFunctions/UserDataFns";
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class UserEditForm extends React.Component
{
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		const loading = this.props.mode !== 'create' ;

		this.state = {loading: loading,
						realloc: false,
						disableTransfer: true,
						displayErrors: false ,
						dirty: false,
						buttonState: '',
					  	usertype: this.props.usertype,
						child_count: 0,
				      	user: { username:'Default Username', 
			                 firstname: '', 
			                 surname: '', 
			                 email: '', 
			                 telNo: '', 
			                 InputPassword1: '', 
			                 InputPassword2: ''}
		};
		
        // This binding is necessary to make `this` work in the callback
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        
        // Input field handlers
        
        this.onUserTypeChange = this.onUserTypeChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this) ;
		this.setChildCount = this.setChildCount.bind(this) ;

	}

	UNSAFE_componentWillMount()
	{
		// This component supports create and edit of users so we need to cater for 
		/// both in the construction of the form
		
		if ( this.props.mode == 'edit' || this.props.mode == 'view' || this.props.mode == 'delete' )
		{
			const userid = this.props.userid ;
			
			if ( userid != null )
			{
				// Fetch the child data for this ESW
				this.getdata (userid) ;			
			}
		
		}							
	}
	
	componentDidMount()
	{
		if ( this.state.loading == false )
		{
			this.refs.UserDetailForm.refs.InputFirstName.focus() ;		
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps == 'edit' || nextProps == 'view' || nextProps == 'delete' )
		{
			var userid = this.props.userid ;
			
			if ( userid != null )
			{
				// Fetch the child data for this ESW
				this.getdata (userid) ;			
			}
		}							
	}
	
	getdata( userid )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
    	$.ajax({
    		  type: 'GET',
    		  url: root + '/users/' + userid  ,
    		  data: { },
    		  success:(data)=>{

    			// We've got something back, so set the data field in the REACT component STATE
    			// THis will be used in the RENDER function
    			 
    			  var el = data.data[0] ;

    			  el.InputPassword1 = '' ;
    			  el.InputPassword2 = '' ;
    			  
    			  this.setState ( {
    			  	  loading: false,
					  realloc: false,
				      disableTransfer: true,
    			  	  usertype: el.userTypeId,
    			  	  user: el 
    			  	  }) ;
    			  
  				// this.setStateFromData(data.data);
  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
  		  		}
    		});
	}

	getCreateTextForUserType(type)
	{
		switch ( +type )
		{
			case UserTypes.ESW:
				return "ESW" ;
			case UserTypes.VIRTUAL_SCHOOL_HEAD:
				return "Virtual School Head" ;
			case UserTypes.PERFORMANCE_AND_DEVELOPMENT :
				return "Performance and Development Officer" ;
			case UserTypes.TEAM_LEAD:
				return "Team Lead" ;
			case UserTypes.EDUCATIONAL_PSYCHOLOGIST:
				return "Educational Psychologist" ;
			case UserTypes.IRO:
				return "Independent Reviewing Officer" ;
			case UserTypes.CAREERS_ADVISOR:
				return "Careers Advisor" ;
			case UserTypes.LEAD_CAREERS_ADVISOR:
				return "Lead Careers Advisor" ;
			case UserTypes.EHCP_COORDINATOR:
				return "EHCP Co-Ordinator" ;
			default:
				return "User" ;
		}
	}

	createESW( userObj )
	{
		createESWUser ( userObj, (response) =>
		{
			const utype = this.props.usertype ;
			const message = "Created new " + this.getCreateTextForUserType(utype) + ". Click OK to return" ;

			bootbox.alert({
				size: "large",
				title: "Operation completed",
				message: message,
				callback: function()
				{
					// return using the filter we originally came in with
					const url = 'view_users.php?usertype=' + utype ;

					location.assign(url);
				}
			})

		})
	}

	deleteDesiTeacher ( user_id )
	{
		var root = Globals.APIFolder ;
		
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'DELETE',
    		  url: root + '/desipersons/'+user_id,
    		  success:(data)=>{

				if ( checkError(data) == true )
				{
					var status = data.status ;

					if ( status.rowsAffected == 0 )
					{
						var title = status.error ;
						var message = status.errorDetail ;						
					}
					else
					{
						var title = "Operation success" ;
						var message = "The Designated person has been deleted. Click OK to return" ;					
					}

					var utype1 = utype ;

					bootbox.alert({ 
						  size: "large",
						  title: title,
						  message: message, 
						  callback: function()
						  { 
								// return using the filter we originally came in with 
								var url = 'view_users.php?usertype=' + utype1 

								location.assign(url);
						  }
						})
				}

  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{
					
					var utype1 = utype ;
					var url = 'view_users.php?usertype=' + utype1 

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
    		  }
    		});
		
	}

	deleteCarer ( user_id )
	{
		var root = Globals.APIFolder ;
		
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'DELETE',
    		  url: root + '/carers/'+user_id,
    		  success:(data)=>{

				if ( checkError(data) == true )
				{
					var status = data.status ;

					if ( status.rowsAffected == 0 )
					{
						var title = status.error ;
						var message = status.errorDetail ;						
					}
					else
					{
						var title = "Operation success" ;
						var message = "The Carer has been deleted. Click OK to return" ;					
					}

					var utype1 = utype ;

					bootbox.alert({ 
						  size: "large",
						  title: title,
						  message: message, 
						  callback: function()
						  { 
								// return using the filter we originally came in with 
								var url = 'view_users.php?usertype=' + utype1 

								location.assign(url);
						  }
						})
				}

  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{
					
					var utype1 = utype ;
					var url = 'view_users.php?usertype=' + utype1 

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
    		  }
    		});
		
	}

	deleteSocialWorker ( user_id )
	{
		var root = Globals.APIFolder ;
		
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'DELETE',
    		  url: root + '/socialworkers/'+user_id,
    		  data: {} ,
    		  beforeSend:function(){
    		  },
    		  success:(data)=>{

				if ( checkError(data) == true )
				{
					var status = data.status ;

					if ( status.rowsAffected == 0 )
					{
						var title = status.error ;
						var message = status.errorDetail ;						
					}
					else
					{
						var title = "Operation success" ;
						var message = "The Social Worker has been deleted. Click OK to return" ;					
					}

					var utype1 = utype ;

					bootbox.alert({ 
						  size: "large",
						  title: title,
						  message: message, 
						  callback: function()
						  { 
								// return using the filter we originally came in with 
								var url = 'view_users.php?usertype=' + utype1 

								location.assign(url);
						  }
						})
				}

  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{
					
					var utype1 = utype ;
					var url = 'view_users.php?usertype=' + utype1 

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
    		  }
    		});
		
	}

	deleteCareersAdvisor ( user_id )
	{
		var root = Globals.APIFolder ;

		var utype = this.props.usertype ;

		$.ajax({
			type: 'DELETE',
			url: root + '/cas/'+user_id,
			success:(data)=>{

				if ( checkError(data) == true )
				{
					var status = data.status ;

					if ( status.rowsAffected == 0 )
					{
						var title = status.error ;
						var message = status.errorDetail ;
					}
					else
					{
						var title = "Operation success" ;
						var message = "The Careers Advisor has been deleted. Click OK to return" ;
					}

					var utype1 = utype ;

					bootbox.alert({
						size: "large",
						title: title,
						message: message,
						callback: function()
						{
							// return using the filter we originally came in with
							var url = 'view_users.php?usertype=' + utype1

							location.assign(url);
						}
					})
				}


			},
			error:(jqXHR, textStatus, error)=>{

				var utype1 = utype ;
				var url = 'view_users.php?usertype=' + utype1

				handleAjaxError ( jqXHR, textStatus, error, url) ;
			}
		});

	}

	deleteESW ( user_id )
	{
		var root = Globals.APIFolder ;
		
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'DELETE',
    		  url: root + '/esws/'+user_id,
    		  data: {} ,
    		  success:(data)=>{

				if ( checkError(data) == true )
				{
					var status = data.status ;

					if ( status.rowsAffected == 0 )
					{
						var title = status.error ;
						var message = status.errorDetail ;						
					}
					else
					{
						var title = "Operation success" ;
						var message = "The ESW has been deleted. Click OK to return" ;					
					}

					var utype1 = utype ;

					bootbox.alert({ 
						  size: "large",
						  title: title,
						  message: message, 
						  callback: function()
						  { 
								// return using the filter we originally came in with 
								var url = 'view_users.php?usertype=' + utype1 

								location.assign(url);
						  }
						})
				}

  				
    		  },
    		  error:(jqXHR, textStatus, error)=>{
					
					var utype1 = utype ;
					var url = 'view_users.php?usertype=' + utype1 

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
    		  }
    		});
		
	}
	
	createDesiTeacher( userObj )
	{
		this.disableButtons() ;

		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = { 'firstname': userObj.firstname, 
				  'surname': userObj.surname, 
				  'password': userObj.password, 
				  'email': userObj.email,
				  'telephone': userObj.telephone,
				  'school_id': userObj.school_id } ;
		
		let utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: root + '/desipersons',
    		  data: j ,
    		  success:(data)=>{

    		  	this.enableButtons();

    			const message = "Created new Designated Teacher. Click OK to return" ;

    			let utype1 = utype ;
    			
    			bootbox.alert({ 
    				  size: "large",
    				  title: "Operation completed",
    				  message: message, 
    				  callback: function()
    				  { 
    						// return using the filter we originally came in with 
    						const url = 'view_users.php?usertype=' + utype1
    							
    						location.assign(url);
    				  }
    				})
    		  },
    		  error:(jqXHR, textStatus, error)=>{
					
					this.enableButtons() ;

					let utype1 = utype ;
					const url = 'view_users.php?usertype=' + utype1

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
    		  }
    		});
	}

	createAttendanceOfficer( userObj )
	{
		this.disableButtons() ;

		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;

		var j = { 'firstname': userObj.firstname,
			'surname': userObj.surname,
			'password': userObj.password,
			'email': userObj.email,
			'telephone': userObj.telephone,
			'school_id': userObj.school_id } ;

		var utype = this.props.usertype ;

		$.ajax({
			type: 'POST',
			url: root + '/attendanceofficers',
			data: j ,
			success:(data)=>{

				this.enableButtons();

				var message = "Created new Attendance Officer Click OK to return" ;

				var utype1 = utype ;

				bootbox.alert({
					size: "large",
					title: "Operation completed",
					message: message,
					callback: function()
					{
						// return using the filter we originally came in with
						var url = 'view_users.php?usertype=' + utype1

						location.assign(url);
					}
				})

				// successful request; do something with the data
				//$('#exampleTextarea').empty();
				//$('#exampleTextarea').val(data.name);
			},
			error:(jqXHR, textStatus, error)=>{

				this.enableButtons() ;

				var utype1 = utype ;
				var url = 'view_users.php?usertype=' + utype1

				handleAjaxError ( jqXHR, textStatus, error, url) ;
			}
		});
	}

	createSocialWorker( userObj )
	{
		this.disableButtons() ;

		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = { 'firstname': userObj.firstname, 
		  		  'surname': userObj.surname,
		  		  'telephone': userObj.telephone,
		  		  'email': userObj.email,
		  		  'address1': userObj.address1, 
		  		  'address2': userObj.address2,
		  		  'address3': userObj.address3, 
		  		  'address4': userObj.address4,
		  		  'postcode': userObj.postcode 
		  		  } ;

		var param = {} ;

		param.socialworker = j ;

		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: root + '/socialworkers',
    		  
    		  data: param ,
    		  success:(data)=>{

				this.enableButtons() ;

    			var utype1 = utype ;
    			
				if ( checkError(data) == true )
				{
					var message = "Created new Social Worker. Click OK to return" ;

					// Display confirmation using the Bootbox library
					// http://bootboxjs.com/
					var utype1 = utype ;

					bootbox.alert({ 
						  size: "large",
						  title: "Operation completed",
						  message: message, 
						  callback: function()
						  { 
								// return using the filter we originally came in with 
								var url = 'view_users.php?usertype=' + utype1 

								location.assign(url);
						  }
						})
				}
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{
					
					this.enableButtons() ;

					var utype1 = utype ;
					var url = 'view_users.php?usertype=' + utype1 

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
		  	
    		  }
    		});
	}

	createIRO( userObj, userType )
	{
		this.disableButtons() ;

		let data = { user_type: userType,
			firstname : userObj.firstname,
			surname : userObj.surname,
			telephone : userObj.telephone,
			email : userObj.email,
			address1 : userObj.address1,
			address2 : userObj.address2,
			address3 : userObj.address3,
			address4 : userObj.address4,
			postcode : userObj.postcode
		} ;

		createUser( data , (response) =>
		{
			this.enableButtons() ;

			const url = 'view_users.php?usertype=' + userType ;

			bootbox.alert({
				size: "large",
				title: "Operation completed",
				message: "User created Successfully",
				callback: function()
				{
					location.assign(url);
				}
			})
		})
	}

	deleteIRO( user_id, userType )
	{
		this.disableButtons() ;

		deleteUser( user_id, userType, (response) =>
		{
			this.enableButtons() ;

			const url = 'view_users.php?usertype=' + userType ;

			bootbox.alert({
				size: "large",
				title: "Operation completed",
				message: "User deleted Successfully",
				callback: function()
				{
					location.assign(url);
				}
			})
		})
	}

	createCareersAdvisor( userObj )
	{
		this.disableButtons() ;

		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;

		var j = { 'firstname': userObj.firstname,
			'surname': userObj.surname,
			'telephone': userObj.telephone,
			'email': userObj.email,
			'address1': userObj.address1,
			'address2': userObj.address2,
			'address3': userObj.address3,
			'address4': userObj.address4,
			'postcode': userObj.postcode
		} ;

		var param = {} ;

		param.socialworker = j ;

		var utype = this.props.usertype ;

		$.ajax({
			type: 'POST',
			url: root + '/cas',

			data: param ,
			success:(data)=>{

				this.enableButtons() ;

				var utype1 = utype ;

				if ( checkError(data) == true )
				{
					var message = "Created new Careers Advisor. Click OK to return" ;

					var utype1 = utype ;

					bootbox.alert({
						size: "large",
						title: "Operation completed",
						message: message,
						callback: function()
						{
							// return using the filter we originally came in with
							var url = 'view_users.php?usertype=' + utype1

							location.assign(url);
						}
					})
				}
			},
			error:(jqXHR, textStatus, error)=>{

				this.enableButtons() ;

				var utype1 = utype ;
				var url = 'view_users.php?usertype=' + utype1

				handleAjaxError ( jqXHR, textStatus, error, url) ;

			}
		});
	}


	createCarer( userObj )
	{
		this.disableButtons() ;

		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var j = { 'firstname': userObj.firstname, 
		  		  'surname': userObj.surname,
		  		  'telephone': userObj.telephone,
		  		  'password': userObj.password,
		  		  'email': userObj.email,
		  		  'address1': userObj.address1, 
		  		  'address2': userObj.address2,
		  		  'address3': userObj.address3, 
		  		  'address4': userObj.address4,
		  		  'postcode': userObj.postcode 
		  		  } ;

		var param = {} ;

		param.carer = j ;

		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: root + '/carers',
    		  
    		  data: param ,
    		  success:(data)=>{

    		  	this.enableButtons() ;

				if ( checkError(data) == true )
				{
					var message = "Created new Carer. Click OK to return" ;

					// Display confirmation using the Bootbox library
					// http://bootboxjs.com/
					var utype1 = utype ;

					bootbox.alert({ 
						  size: "large",
						  title: "Operation completed",
						  message: message, 
						  callback: function()
						  { 
								// return using the filter we originally came in with 
								var url = 'view_users.php?usertype=' + utype1 

								location.assign(url);
						  }
						})
				}
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{

    		  		this.enableButtons() ;
					
					var utype1 = utype ;
					var url = 'view_users.php?usertype=' + utype1 

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
    		  }
    		});
	}
	
	updateUser( userObj )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;

		var userid = userObj.user_id ; 

		var j = userObj ;

		if ( userObj.school_id != null )
		{
			j.school_id = userObj.school_id ; 
		}

		if ( userObj.new_school_id != null )
		{
			// If user's school has changed
			j.new_school_id = userObj.new_school_id ; 			
		}

		var d = {} ;

		d.user = j ;
				
		var utype = this.props.usertype ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: root + '/users/'+userid,
    		  //dataType: "json",
    		  //contentType: "application/json; charset=utf-8",
    		  
    		  data: d ,
    		  success:(data)=>{

    			var res = data.status.result ;
    			
    			if ( res == 'success' )
				{
        			var message = "Updated user details. Click OK to return" ;
      			  
        			// Display confirmation using the Bootbox library
        			// http://bootboxjs.com/
        			var utype1 = utype ;
        			
        			var returl = atob(this.props.return_url) ;

        			bootbox.alert({ 
        				  size: "large",
        				  title: "Operation completed",
        				  message: message, 
        				  callback: function()
        				  {         							
        						location.assign(returl);
        				  }
        				})				
				}
    			else
				{
    				var message = "Failed = " + data.status.errorDetail.message ;
        			var returl = atob(this.props.return_url) ;
    				
        			bootbox.alert({ 
      				  size: "large",
      				  title: "Operation failed",
      				  message: message, 
      				  callback: function()
      				  { 
      						location.assign(returl);
      				  }
      				})				
				}
  				
    		    // successful request; do something with the data
    		    //$('#exampleTextarea').empty();
    		    //$('#exampleTextarea').val(data.name);
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					var url = atob(this.props.return_url) ;

					handleAjaxError ( jqXHR, textStatus, error, url) ;    		  	
   		  	
    		  }
    		});
	}
	
	doTransferChildren( from_user_id, to_user_id )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var url = '/desipersons/' + from_user_id + '/children/reassign/' + to_user_id ;
		
		var self = this ;
		
    	$.ajax({
    		  type: 'PUT',
    		  url: root + url,
    		  data: {} ,
    		  success:(data)=>{

    			  if ( checkError(data))
    			  {
          			bootbox.alert({ 
      				  size: "large",
      				  title: "Transfer completed",
      				  message: "The teacher can now be edited", 
      				  callback: function()
      				  {         							
      					  self.getdata (from_user_id) ;
      				  }
      				})				    				  
    			  }    			  
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					handleAjaxError ( jqXHR, textStatus, error) ;    		  	
    		  }
    		});
	}
	formIsValid ()
	{		
		var type = this.state.usertype ;
	
		if ( this.props.mode == 'edit')
		{
			// In edit mode, we don't present the password
			if ( this.refs.UserDetailForm.formIsValid())
			{
				return true ;
			}
			else
			{
				return false ;
			}
		}
		else if ( this.props.mode == 'create')
		{
			var result = true ;

			if ( this.refs.UserDetailForm.formIsValid())
			{
				result = true ;
			}
			else
			{
				result = false ;
			}

			if ( this.isSchoolBasedRole(type) )
			{
				if ( !this.refs.InputSchool.isValid())
				{
					result = false ;
				}
			}

			return result ;
		}
		else if ( this.props.mode == 'delete')
		{
			return true ;
		}
	}

	isSchoolBasedRole ( type )
	{
		return (+type === UserTypes.DESI_TEACHER || +type === UserTypes.ATTENDANCE_OFFICER) ;
	}

	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var formUserData = this.refs.UserDetailForm.getFormData() ;

			var userObj = {} ;

			userObj.username = formUserData.username ;
			userObj.firstname = formUserData.firstname ;
			userObj.surname = formUserData.lastname ;
			userObj.email = formUserData.email ;
			userObj.telephone = formUserData.telephone ;

			if (  !this.isSchoolBasedRole(this.state.usertype))
			{
				userObj.address1 = formUserData.address1 ;
				userObj.address2 = formUserData.address2 ;
				userObj.address3 = formUserData.address3 ;
				userObj.address4 = formUserData.address4 ;
				userObj.postcode = formUserData.postcode ;				
			}

			userObj.usertype = this.state.usertype ;

			if ( this.state.dirty == true )
			{
				userObj.school_id = this.state.user.school_id ;			
			}

			if ( this.props.mode === 'create')
			{
				userObj.password = formUserData.password;

				const userType = +userObj.usertype ;

				if ( userType === UserTypes.ESW || userType === UserTypes.VIRTUAL_SCHOOL_HEAD ||
					userType === UserTypes.PERFORMANCE_AND_DEVELOPMENT || userType === UserTypes.TEAM_LEAD ||
					userType === UserTypes.EDUCATIONAL_PSYCHOLOGIST || userType === UserTypes.CAREERS_ADVISOR ||
					userType === UserTypes.LEAD_CAREERS_ADVISOR || userType === UserTypes.EHCP_COORDINATOR )
				{
					// ESLAC role
					
					this.createESW ( userObj) ;
				}
				else if ( userType === UserTypes.DESI_TEACHER )
				{
					this.createDesiTeacher ( userObj ) ;
				}
				else if ( userType === UserTypes.SOCIAL_WORKER )
				{
					this.createSocialWorker ( userObj ) ;
				}
				else if ( userType === UserTypes.IRO || userType === UserTypes.EWS_OFFICER )
				{
					this.createIRO ( userObj, userType ) ;
				}
				else if ( userType === UserTypes.CARER )
				{
					this.createCarer ( userObj ) ;
				}
				else if ( userType === UserTypes.ATTENDANCE_OFFICER )
				{
					this.createAttendanceOfficer ( userObj ) ;
				}
			}
			else
			{
				if ( this.props.mode === 'edit')
				{
					userObj.user_id = this.state.user.idusers ;

					if ( +(userObj.usertype) === UserTypes.DESI_TEACHER )
					{
						// Teacher so check to see if the schoiol has changed
						
						var school_id = this.refs.InputSchool.getValue() ;

						if ( this.state.user.school != null )
						{
							var originalSchool = this.state.user.school.school_id ;			

							if ( originalSchool != school_id )
							{
								userObj.new_school_id = school_id ;
							}
						}

						userObj.login_enabled = formUserData.login_enabled ;
					}					

					this.updateUser ( userObj ) ;
				}			
			}
		}
	}

	onDelete() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			const userType = +(this.state.usertype) ;

			if ( userType === UserTypes.DESI_TEACHER )
			{
				this.deleteDesiTeacher ( this.props.userid ) ;
			}
			else if ( userType === UserTypes.SOCIAL_WORKER )
			{
				this.deleteSocialWorker ( this.props.userid ) ;
			}
			else if ( userType === UserTypes.CARER )
			{
				this.deleteCarer ( this.props.userid ) ;
			}
			else if ( userType === UserTypes.PERFORMANCE_AND_DEVELOPMENT || userType === UserTypes.ESW )
			{
				this.deleteESW ( this.props.userid ) ;
			}
			else if ( userType === UserTypes.IRO || userType === UserTypes.EWS_OFFICER )
			{
				this.deleteIRO( this.props.userid , userType ) ;
			}
			else if ( +(this.state.usertype) === USER_TYPE_CAREERS_ADVISOR )
			{
				if ( this.state.child_count !== 0 )
				{
					bootbox.alert({
						size: "large",
						title: "Operation Not Allowed",
						message: "You cannot delete this user while they have allocated pupils",
						callback: function()
						{
						}
					})
				}
				else
				{
					this.deleteCareersAdvisor ( this.props.userid );
				}
			}
		}	
	}

	disableButtons()
	{
		this.setState ( { buttonState: 'disabled'}) ;
	}
	
	enableButtons()
	{
		this.setState ( { buttonState: ''}) ;
	}
	
	onCancel() 
	{
		// return using the filter we originally came in with 
		
		var url = atob ( this.props.return_url ) ;
			
		location.assign(url);
	}
	
	onUserTypeChange(roleId, roleText) 
	{
		this.setState ( { usertype : roleId }) ;
	}

	doesUserTypeRequirePassword( usertype )
	{
		var showPasswordFields = false ;

		switch ( usertype )
		{
			case UserTypes.ESW: // ESW
				showPasswordFields = false ;
				break;
			case UserTypes.DESI_TEACHER: // Teacher
				showPasswordFields = false ;
				break;
			case UserTypes.VIRTUAL_SCHOOL_HEAD: // Virtual School Head
				showPasswordFields = false ;
				break;
			case UserTypes.SOCIAL_WORKER: // Social Worker
				showPasswordFields = false ;
				break;
			case UserTypes.CARER: // Carer
				showPasswordFields = false ;
				break;
			default:
				showPasswordFields = false ;
				break ;
		}	

		return showPasswordFields ;
	}

	doesUserTypeAutogeneratePassword( usertype )
	{
		var doesAutogenerate = false ;

		switch ( usertype )
		{
			case 5: // Teacher
				doesAutogenerate = true ;
				break;
			case 3: // Teacher
				doesAutogenerate = true ;
				break;
			case 6: // Head
				doesAutogenerate = true ;
				break;
			case 2: // Team Lead
				doesAutogenerate = true ;
				break;
			case 11: // Adele
				doesAutogenerate = true ;
				break;
			default:
				doesAutogenerate = false ;
				break ;
		}	

		return doesAutogenerate ;
	}	
	
	formRowNewUserEdit()
	{
		var showPasswordFields = false ;
		var autoGeneratePassword = false ;
		var addressRequired = true ;

		if ( this.props.mode == 'create')
		{
			showPasswordFields = this.doesUserTypeRequirePassword ( +this.props.usertype ) ;
			
			autoGeneratePassword = this.doesUserTypeAutogeneratePassword ( +this.props.usertype ) ;
		}

		if ( this.isSchoolBasedRole(this.state.usertype))
		{
			addressRequired = false ;
		}

		return React.createElement ( UserEditForm2, { 
			ref: 'UserDetailForm',
			user: this.state.user,
			mode: this.props.mode,
			userType: this.state.usertype,
			displayMode: 'form',			
			passwordRequired: showPasswordFields,
			autoGeneratePassword: autoGeneratePassword,
			addressRequired: addressRequired,
			showButtons: this.state.carerFormButtonShow,
			onCancel: this.onCancel.bind(this),
			onSave: this.onSave.bind(this),
			onDelete: this.onDelete.bind(this),
			key: '99' } ) ;		
	}
	
	onSchoolChange ( schoolObj )
	{
		var user = this.state.user ;

		user.school_id = schoolObj.school_id ;

		this.setState ({dirty: true, user: user }) ;
	}

	schoolRow()
	{
        var lineList=[];

		if ( this.state.user.school_id == null )
		{
			if ( this.state.user.school != null )
			{
				var school_id = this.state.user.school.school_id ;
			}
			else
			{
				var school_id = -1 ;
			}
		}
		else
		{
			var school_id = this.state.user.school_id ;
		}

		if ( this.state.user.children == null )
		{
			var readonly = '';
			var label = "Select a school (Use the filter to narrow down the list)" ;
		}
		else
		{
			var readonly = 'readonly' ;
			var label = "You cannot modify this teacher's school" ;
		}

        /* lineList.push (  React.createElement ( 'div',{key: 'InputSchool', className: 'col-md-12'},
        			React.createElement ( FilteredSchoolDropdown, { 
        			ref: 'InputSchool',
        			defaultItemId: school_id,
        			readOnly: readonly,
        			key: this.keyCount++, 
        			mode: 'list',
        			displayErrors: this.state.displayErrors,
        			validation: { required: true },
        			errorText: "You must assign the teacher to a school",
        			label: label,
        			callback: this.onSchoolChange.bind ( this)}, null ))); 		 */

		if ( this.state.user.children != null )
		{
	        lineList.push (  React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-12'},
        			React.createElement ( 'span', { key: 'warning' }, 
        			"You cannot change this teacher's school because they have assigned children. Click the link below to reallocate these children to another teacher if you wish to delete this user or change the teacher's school " )));

	        lineList.push ( this.reallocRow()) ;
		}
		

		return React.createElement('div', { key: this.keyCount++, className: 'row' }, lineList ) ;
		
	}

	reallocRow()
	{
		if ( this.state.realloc == true )
		{
			return this.reallocForm() ;
		}
		else
		{
			return this.popup_hyperlink ( "Click here to re-allocate all of the teacher's children to another teacher at the same school.");					
		}	
	}
	
	onDesiTeacherDropdownChange ( user )
	{
		if ( user != null )
		{
			if ( user.idusers != this.state.user.idusers)
			{
				this.setState ({disableTransfer: false}); 		
			}		
		}
	}
	
	reallocButtonRow()
	{
		var lineList = [] ;

		if ( this.state.disableTransfer == true )
		{
			var disableButton = 'disabled' ;
		}
		else
		{
			disableButton = '' ;
		}
		
		lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-6'},null)) ;

        lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-6', style: { marginTop: '10px', paddingRight: '0px'}},
        		 React.createElement('button', { id: 'SaveButton', disabled: disableButton, type: 'button', className: 'btn btn-primary', style: { float: 'right', marginRight: '0px' } , onClick: this.onTransfer.bind(this) }, 'Transfer Children'),
           		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancelReallocate.bind(this) }, 'Cancel')))
           		 
        return React.createElement ( 'div', { key: this.keyCount++}, lineList) ;
	}
		
	reallocForm()
	{
        var lineList=[];
        
        lineList.push (  React.createElement ( DropdownDesignatedTeachers, { 
    				validation : { required: true },
    				ref: 'InputDesiTeacher',
    				key: 'dropdownDesiTeachers',
    				school_id: this.state.user.school.school_id,
    				defaultItemId: null,
    				mode: 'list',
    				readOnly: false, 
    				label: 'Select a teacher to transfer the children to',
    				errorText: 'You must select a Designated Teacher',
    				displayErrors:this.state.displayErrors,
    				onChange: this.onDesiTeacherDropdownChange.bind ( this)}, null )) ;		
        
        lineList.push ( this.reallocButtonRow()) ;
        
		return React.createElement('div', { key: 'DivInputDesiTeacher', className: 'col-md-12' }, lineList ) ;
	}
	
	onReallocate()
	{
		this.setState ({disableTransfer: true, realloc: true }); 
	}

	onTransfer()
	{
		var self = this ;
		
		bootbox.confirm({
		    title: "Transfer All Children?",
		    message: "Are you sure you wish to transfer all this teacher's children to another teacher?",
		    buttons: {
		        cancel: {
		            label: '<i class="fa fa-times"></i> Cancel'
		        },
		        confirm: {
		            label: '<i class="fa fa-check"></i> Confirm'
		        }
		    },
		    callback: function (result) 
		    {
		    	if ( result == true )
		    	{
		    		var target_user_id = self.refs.InputDesiTeacher.getValue() ;
		    		
		    		self.doTransferChildren ( self.state.user.idusers, target_user_id ) ;
		    	}
		    }
		});

	}

	onCancelReallocate()
	{
		this.setState ({realloc: false }); 
	}
	
	popup_hyperlink ( label )
	{
		return React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-12', style: { marginTop: '10px'}},
				React.createElement ( 'span', { }, 
				React.createElement ( 'a', { href: '#', onClick: this.onReallocate.bind(this) } , label ))) ;
	}
	
	buttonRow ()
    {
        var lineList=[];
        
        if ( this.props.mode == 'delete')
    	{
            lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

            lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
            		 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-danger', style: { float: 'right', marginRight: '15px' } , onClick: this.onDelete.bind(this) }, 'Delete'),
               		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
    	
    	}
        else
    	{
    		if ( this.props.mode == 'edit' || this.props.mode == 'create')
    		{
                lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
                		 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' ,  marginTop: '10px', marginRight: '0px'} , onClick: this.onSave.bind(this) }, 'Save'),
                   		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginTop: '10px', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))

    		}
    		else
    		{
    			lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

                lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
                   		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right' }, onClick: this.onCancel.bind(this) }, 'Close')))

			}
        	
    	}
           		        
        return React.createElement('div', { key: this.keyCount++, className: 'row' }, lineList ); 
    }

	childrenRow( role )
	{
        return React.createElement('div', { key: this.keyCount++, className: 'row' , style: { paddingTop: '10px'}},
        		 	React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-12'},
        			React.createElement ( DesiTeacherChildrenPanel, { 
        			role: role,	
        			user_id: this.props.userid,
					setChildCount: this.setChildCount,
        			key: this.keyCount++ }, null ))); 		
	}

	handleFilterChange(usertype, text)
	{
		if ( usertype != this.state.usertype )
		{
			this.setState ( { usertype : usertype }) ;
		}
	}

	rowRoleSelect()
	{
		let lineList = [] ;

		if ( this.props.mode == 'create')
		{
			lineList.push( React.createElement ('div', { className: 'row', key: 'dropDowndiv', style: { marginBottom: '10px'} } ,
				React.createElement ('div', { className: 'col-md-12', key: 'dropDowndivCol' } ,
				React.createElement ( DropdownRole, {
					key: this.keyCount++,
					initialValue: { value: this.state.usertype },
					label: 'Filter on a Role',
					isClearable: true,
					onChange: (option) => this.handleFilterChange( option === null ? 0 : option.value, option === null ? 'All' : option.label ) } , null)))) ;
		}

		return lineList ;
	}

	setChildCount = (count) =>
	{
		this.setState ({child_count: count});
	}

	mainFormElement ()
    {
	    var lineList=[];

		lineList.push ( this.rowRoleSelect()) ;

		lineList.push ( this.formRowNewUserEdit()) ;
	    
	    if ( this.isSchoolBasedRole(this.state.usertype)) // Desi Teacher
	    {
		    lineList.push ( this.schoolRow()) ;

		    if ( this.props.mode != 'create' && this.state.usertype == USER_TYPE_DESI_TEACHER )
	    	{
			    lineList.push ( this.childrenRow('desiteacher')) ;	    	
	    	}
	    }

	    if ( this.state.usertype == 10 && this.props.mode != 'create') // Carer
	    {
		    lineList.push ( this.childrenRow('carer')) ;
	    }
	    
	    if ( this.state.usertype == 9 && this.props.mode != 'create') // Carer
	    {
		    lineList.push ( this.childrenRow('socialworker')) ;
	    }

		if ( this.state.usertype == 12 && this.props.mode != 'create') // Carer
		{
			lineList.push ( this.childrenRow('edpsych')) ;
		}

		if ( this.state.usertype == 15 && this.props.mode != 'create') // Carer
		{
			lineList.push ( this.childrenRow('cas')) ;
		}

		if ( this.state.usertype == 3 && this.props.mode != 'create') // ESW
	    {
		    lineList.push ( this.childrenRow('esw')) ;
	    }

	    return React.createElement ( 'div', { role: 'form', className: 'panel-body', id: 'createForm'}, lineList) ;
    }

	render() 
    {
		this.keyCount=0;

    	if ( this.state.loading == true )
    	{
	        return <SpinnerDiv />
    	}
    	else
		{
			return <div className="jumbotron">
				<p className="med">Edit User</p>
				{ this.mainFormElement() }
			</div>
		}
    }
};